import { InputNumber } from "antd";
import TextField2 from "../textfields/TextField2";
import PrimaryButton from "../buttons/PrimaryButton";
import Icon1 from "../icons/Icon";
import SecondaryButton from "../buttons/SecondaryButton";

import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";
import { useSnackbar } from "notistack";
import { Switch, useTheme } from "@mui/material";
import SmallSpinner from "../loading/SmallSpinner";
import { useNavigate } from "react-router-dom";
import Space from "../layout/Space";
import { use, useEffect, useState } from "react";
import Modal1 from "../modals/Modal1";
import Payment from "./PaymentModal";
import createDocApi from "../api/database/createDocApi";
import { useAppContext } from "../config/AppContext";
import deleteDocApi from "../api/database/deleteDocApi";
import { addActivityLog } from "../config/OnlineStatus";
import { EasySwitch } from "../textfields/EasySwitch";
import WarningButton from "../buttons/WarningButton";
import UploadRapportPayment from "../api/upload/UploadRapportPayment";
import PaymentRapportVisualisateur from "./PaymentRapportVisualisateur";
import {
  getArrayDocDataByID,
  getArrayDocRefByIDs,
  getDocDataByRef,
  getFlutterTime,
  queryCollection,
} from "../models/DataFunctions";
import UploadFacturePayment from "../api/upload/UploadFacturePayment";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import { format } from "date-fns";
import { getRefFromId } from "../models/DataFunctions";
import { deleteDoc } from "firebase/firestore";
import sendInfiltreaDeleteMission from "../api/infiltrea/sendInfiltreaDeleteMission";
import sendInfiltreaGetReports from "../api/infiltrea/sendInfiltreaGetReports";
import sendPennylaneDeleteDraftInvoice from "../api/pennylane/sendPennylaneDeleteDraftInvoice";
import sendPennylaneGetInvoiceUrl from "../api/pennylane/sendPennylaneGetInvoiceUrl";
import sendPennylaneFinalizeInvoice from "../api/pennylane/sendPennylaneFinalizeInvoice";
import sendPennylaneSaveInvoiceReglement from "../api/pennylane/sendPennylaneSaveInvoiceReglement";
import DropDownGPT0X from "../dropdowns/DropDownGTP0X";
import updateDocApi from "../api/database/updateDocApi";

const renderLogLines = (logs) => {
  const lines = logs.split("\n");
  const groups = [];
  let currentTableLines = [];

  const flushTable = () => {
    if (currentTableLines.length > 0) {
      groups.push({ type: "table", lines: currentTableLines });
      currentTableLines = [];
    }
  };

  lines.forEach((line) => {
    if (line.includes("|")) {
      currentTableLines.push(line);
    } else {
      flushTable();
      groups.push({ type: "text", line });
    }
  });
  flushTable();

  return groups.map((group, gi) => {
    if (group.type === "text") {
      const line = group.line;
      return (
        <div
          key={gi}
          className={
            line.includes("[ERROR]")
              ? "text-red-500 font-medium"
              : line.startsWith("---")
              ? "text-blue-500 font-medium mt-2 mb-1"
              : "text-shadow_50"
          }
        >
          {line}
        </div>
      );
    }
    return (
      <table
        key={gi}
        className="w-full text-left border-collapse mb-1"
      >
        <tbody>
          {group.lines.map((line, li) => {
            const cells = line.split("|").map((c) => c.trim());
            return (
              <tr key={li} className="border-b border-neutral-100">
                {cells.map((cell, ci) => (
                  <td
                    key={ci}
                    className={`py-0.5 pr-3 ${
                      ci === 0
                        ? "font-medium text-neutral-700 whitespace-nowrap"
                        : "text-shadow_50"
                    }`}
                  >
                    {cell}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  });
};

const MissionVMCFolder = ({ userData, orgData, folderData, handleRefresh }) => {
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [deleteOpen, setDeleteOpen] = useState(null);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [payment_open, setPaymentOpen] = useState(null);
  const theme = useTheme();
  const [missions_vmc, setMissionsVmc] = useState([]);
  const [loadingMissions, setLoadingMissions] = useState(true);
  const [loadingDeleteMission, setLoadingDeleteMission] = useState(null);
  const [loadingOpenInvoice, setLoadingOpenInvoice] = useState(null);
  const [loadingFinalizeInvoice, setLoadingFinalizeInvoice] = useState(null);
  const [loadingReportsMission, setLoadingReportsMission] = useState(null);
  const [openRapports, setOpenRapports] = useState(null);

  const [loadingData, setLoadingData] = useState(false);
  const [slots_items, setSlotsItems] = useState([]);
  const [selected_slot, setSelectedSlot] = useState(null);
  const handleFetchData = async () => {
    let missionvmcs = await getArrayDocDataByID(
      "missionvmc",
      folderData.missionvmc_ids || []
    );
    console.log("missionvmcs", missionvmcs);

    setMissionsVmc(missionvmcs);
    setLoadingMissions(false);
  };

  useEffect(() => {
    if (!folderData) return;
    handleFetchData();
  }, [folderData]);

  // Auto-poll every 10s while any mission is pending
  useEffect(() => {
    const hasPending = missions_vmc.some((m) => m.oecvmc_status === "pending");
    if (!hasPending) return;
    const interval = setInterval(() => {
      handleFetchData();
    }, 10000);
    return () => clearInterval(interval);
  }, [missions_vmc]);

  if (loadingMissions) {
    return <SmallSpinner></SmallSpinner>;
  }

  return (
    <div className="flex flex-col h-fit gap-2 justify-end items-start mt-2">
      <div className="flex flex-col gap-2 w-full">
        {missions_vmc
          .sort((a, b) => b.created_at - a.created_at)
          .map((mission, index) => (
            <div
              key={index}
              className={`flex flex-col border-l-2  space-1  p-2 ${"border-neutral-400 "}`}
            >
              <div className="text-h3 font-light flex flex-row items-center gap-2">
                {mission.type}
                {mission.oecvmc_status === "success" && (
                  <span className="text-h4 text-green-600 bg-green-50 border border-green-200 px-2 py-0.5 rounded-md">
                    Envoyé
                  </span>
                )}
                {mission.oecvmc_status === "failed" && (
                  <span className="text-h4 text-red-600 bg-red-50 border border-red-200 px-2 py-0.5 rounded-md">
                    Échec d'envoi
                  </span>
                )}
                {mission.oecvmc_status === "pending" && (
                  <span className="text-h4 text-blue-600 bg-blue-50 border border-blue-200 px-2 py-0.5 rounded-md flex items-center gap-1">
                    <span className="animate-spin inline-block w-3 h-3 border-2 border-blue-400 border-t-transparent rounded-full"></span>
                    Traitement en cours...
                  </span>
                )}
                {!mission.oecvmc_status && (
                  <span className="text-h4 text-neutral-500 bg-neutral-50 border border-neutral-200 px-2 py-0.5 rounded-md">
                    En attente
                  </span>
                )}
                <div className="text-h3 ">
                  {mission.folder_vmc_id}
                </div>{" "}
              </div>
              {mission.report_sent_at && (
                <div className="text-h3  text-green-500 my-2 flex flex-row border items-center gap-2 bg-green-50 px-2 py-1 w-fit rounded-lg">
                  <Icon1 icon_name="done2" size={18} fill="#22c55e" />
                  Rapport reçu le{" "}
                  {
                    mission.report_sent_at &&
                      format(
                        mission.report_sent_at?.toDate(),
                        "dd/MM/yyyy HH:mm:ss"
                      ) // Convert the Timestamp and format it
                  }
                </div>
              )}

              {mission.extraction_logs && (
                <details className="mt-1">
                  <summary className="text-h4 text-blue-600 cursor-pointer hover:underline">
                    Logs d'extraction
                  </summary>
                  <div className="text-h4 bg-neutral-50 border border-neutral-200 rounded-md p-2 mt-1 font-mono max-h-c200 overflow-auto">
                    {renderLogLines(mission.extraction_logs)}
                  </div>
                </details>
              )}
              <div className="text-h3  text-shadow_50">
                Mission créée le{" "}
                {
                  mission.created_at &&
                    format(mission.created_at?.toDate(), "dd/MM/yyyy HH:mm:ss") // Convert the Timestamp and format it
                }
              </div>
            </div>
          ))}
      </div>{" "}
      {missions_vmc.length === 0 && (
        <div className="flex flex-col  w-fit rounded-xl items-center h-fit my-1 bg-neutral-50 p-2 border-l-3 border-neutral-400 ">
          <div className="text-h3 text-neutral-400 font-medium   gap-2 flex flex-row items-center">
            <Icon1 icon_name="pennylane" fill="grey" size={18} />
            Aucune mission vmc créée pour ce dossier
          </div>
        </div>
      )}
    </div>
  );
};

export default MissionVMCFolder;
